import CustomStore from "devextreme/data/custom_store";
import useApiConfiguration from "../apiConfig";
import { RapportiniApi } from "../data/apis";
import { useMemo } from "react";

export function useRapportinoDataSource(personaleId: number, daData: Date, aData: Date) {
    const apiConfiguration = useApiConfiguration();

    const dataSource = useMemo(() => {
        const api = new RapportiniApi(apiConfiguration);

        return new CustomStore({
            key: 'id',
            loadMode: 'raw',
            load: (loadOptions) => {
                return api.getRapportini({
                    personaleId: personaleId,
                    daData: daData,
                    aData: aData
                })
            }
        })
    }, [personaleId, daData, aData, apiConfiguration]);

    return dataSource;
}